import {Suspense} from 'react'
import {graphql, useLazyLoadQuery} from 'react-relay/hooks'
import {Outlet, useParams} from 'react-router-dom'

import {Show} from '@chakra-ui/react'

import {
  LoadingPage,
  PageNavigation,
  PageNavigationGroup,
  PageNavigationItem,
} from 'components'
import {SiteLayout} from 'pages/site/components'

import {ProviderRootQuery} from './__generated__/ProviderRootQuery.graphql'
import {Header} from './components/Header'

export function ProviderRoot() {
  const {slug} = useParams()
  const {provider} = useLazyLoadQuery<ProviderRootQuery>(
    graphql`
      query ProviderRootQuery($slug: String!) {
        provider(slug: $slug) {
          ...Header_provider
          pages(first: 10) {
            edges {
              node {
                id
                slug
                tabTitle
              }
            }
          }
        }
      }
    `,
    {slug}
  )

  return (
    <SiteLayout>
      <Header provider={provider} />

      <PageNavigation>
        <PageNavigationGroup>
          <PageNavigationItem end to={`/${slug}`}>
            Overview
          </PageNavigationItem>
          <Show below="md">
            <PageNavigationItem to="about">About</PageNavigationItem>
          </Show>
          {provider.pages.edges.map((edge) => (
            <PageNavigationItem
              key={edge.node.id}
              to={`info/${edge.node.slug}`}
            >
              {edge.node.tabTitle}
            </PageNavigationItem>
          ))}
        </PageNavigationGroup>
      </PageNavigation>

      <Suspense fallback={<LoadingPage />}>
        <Outlet />
      </Suspense>
    </SiteLayout>
  )
}
